import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

const Clients = () => {
    return (
        <section id="clients" className="clients section-bg">
            <div className="container" data-aos="fade-up">
                <div className="section-title">
                    <h2>Our Clients</h2>
                </div>
                <div className="container" data-aos="zoom-in">
                    <Swiper
                        loop={true}
                        speed={600}
                        autoplay={{ delay: 5000 }}
                        slidesPerView="auto"
                        breakpoints={{
                            320: { slidesPerView: 2, spaceBetween: 40 },
                            480: { slidesPerView: 3, spaceBetween: 60 },
                            640: { slidesPerView: 4, spaceBetween: 80 },
                            992: { slidesPerView: 5, spaceBetween: 120 },
                            1200: { slidesPerView: 6, spaceBetween: 120 }
                        }}
                        modules={[Autoplay]}
                        className="swiper-container"
                        pagination={false}  // 🔹 Hide pagination dots
                    >
                        <SwiperSlide><img src="https://www.mmcspl.com/img/RLIC_logo.png" className="custom-img-size" alt="" /></SwiperSlide>
                        <SwiperSlide><img src="https://www.mmcspl.com/img/Sunrise_logo.png" className="custom-img-size" alt="" /></SwiperSlide>
                        <SwiperSlide><img src="https://www.mmcspl.com/img/Bandhan_bank_logo.png" className="custom-img-size" alt="" /></SwiperSlide>
                        <SwiperSlide><img src="https://www.mmcspl.com/img/Bosch-Limited-Logo.png" className="custom-img-size" alt="" /></SwiperSlide>
                        <SwiperSlide><img src="https://www.mmcspl.com/img/FRN_logo.png" className="custom-img-size" alt="" /></SwiperSlide>
                        <SwiperSlide><img src="https://www.mmcspl.com/img/ING_Vysya_Bank.png" className="custom-img-size" alt="" /></SwiperSlide>
                        <SwiperSlide><img src="https://www.mmcspl.com/img/KC_logo.png" className="custom-img-size" alt="" /></SwiperSlide>
                        <SwiperSlide><img src="https://www.mmcspl.com/img/NCBL_logo.png" className="custom-img-size" alt="" /></SwiperSlide>
                        <SwiperSlide><img src="https://www.mmcspl.com/img/PTC_logo.png" className="custom-img-size" alt="" /></SwiperSlide>
                        <SwiperSlide><img src="https://www.mmcspl.com/img/RBI_LOGO.png" className="custom-img-size" alt="" /></SwiperSlide>
                    </Swiper>
                </div>
            </div>
        </section>
    );
};

export default Clients;
